@if (compact()) {
  <div class="bucket-type-compact">
    <label class="sr-only" [for]="inputIdPrefix + '-select'">{{ legend() }}</label>
    <select
      [id]="inputIdPrefix + '-select'"
      appUiInput
      class="bucket-type-compact-select"
      [disabled]="disabled()"
      [ngModel]="type()"
      (ngModelChange)="onTypeChange($event)"
      [attr.aria-label]="legend()"
    >
      @for (option of options; track option.value) {
        <option [ngValue]="option.value">{{ option.label }}</option>
      }
    </select>
  </div>
} @else {
  <app-ui-radio-group
    class="bucket-type-options block"
    appearance="card"
    [columns]="2"
    [legend]="legend()"
    [name]="name()"
    [options]="radioOptions"
    [value]="type()"
    [disabled]="disabled()"
    (valueChange)="onRadioChange($event)"
  />
}
